export default __webpack_public_path__ + "static/media/keller-before-after2-mobile-1.dd4c9ba5.svg";